module.exports = __webpack_public_path__ + "img/case1_2.d3b23263.png";